import { useEffect, useState } from "react";
import { HexColorPicker } from "react-colorful"
import { toast } from "react-toastify";
import axios from "../../../../api/axios";
import { updateCampaignColoursRoute } from "../../../../api/routes";
import FormField from "../../../../components/forms/FormField/FormField";
import { IconJsxer } from "../../../../helpers/IconHelper";

const EditColourPalletteContent = (props) => {
    const [currentVal, setCurrentVal] = useState(props.colourHex || '#9146FF');
    const [editingVal, setEditingVal] = useState(props.colourHex || '#9146FF');
    const [editingColour, setEditingColour] = useState(props.colourName || 'PRIMARY');
    const [editingIndex, setEditingIndex] = useState(props.colourIndex || 0);
    const campaignData = props.campaignData;
    const [editedCampaignColours, setEditedCampaignColours] = useState([...campaignData.colours]);

    const addNewColour = () => {
        props?.hideTooltipFunc?.();
        
        const newColourHex = editedCampaignColours[editedCampaignColours.length - 1];
        setEditingColour('COLOR' + (editedCampaignColours.length + 1));
        setEditingIndex(editedCampaignColours.length);
        setCurrentVal(newColourHex);
        setEditingVal(newColourHex);
        setEditedCampaignColours((prevColours) => {
            const newColours = [...prevColours];
            newColours.push(newColourHex);
            return newColours;
        });
    }

    const setVal = (newVal) => {
        setCurrentVal(newVal);
    }

    const confirmVal = (newVal) => {
        let validColour = false;
        if (newVal.substring(0, 1) !== '#') {
            newVal = '#' + newVal;
        }
        if (/^#[0-9A-F]{6}$/i.test(newVal) && newVal.length === 7) {
            validColour = true;
        }
        if (!validColour) {
            setCurrentVal(editingVal);
            return;
        }

        setEditedCampaignColours((prevColours) => {
            const newColours = [...prevColours];
            newColours[editingIndex] = newVal;
            setEditingVal(newVal);
            setCurrentVal(newVal);
            return newColours;
        });
    }

    const saveChanges = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!props.busy) {
            props.setBusy(true);
        }

        // Save the changes to the campaign data
        axios
            .post(updateCampaignColoursRoute, {
                colours: editedCampaignColours,
                campaignID: props.campaignData._id,
                withCredentials:true
            })
            .then((res) => {
                if (res.data.success) {
                    toast.success('Campaign pallette updated successfully');
                    props.campaignData.colours = [...editedCampaignColours];
                    props.exitEditMode();
                } else {
                    toast.error('Error updating campaign pallette');
                    console.error('Error updating campaign pallette: ', res.data.message);
                    props.exitEditMode();
                }
            })
            .catch((err) => {
                toast.error('Error updating campaign pallette');
                console.error('Error updating campaign pallette: ', err);
                props.setBusy(false);
            });
    }

    useEffect(() => {
        if (props.colourIndex && props.colourIndex >= props.campaignData.colours.length) {
            // Add a new colour to the array
            setEditedCampaignColours((prevColours) => {
                const newColours = [...props.campaignData.colours];
                newColours.push(props.colourHex || '#9146FF');
                return newColours;
            });
            setEditingIndex(props.campaignData.colours.length);
            setEditingColour('COLOR' + (props.campaignData.colours.length + 1));
        }
    }, []);

    return (
        <div className="form-field-content-holder">
            <div className="form-field-content">
                {/* <h5>Edit Color Pallette</h5> */}
                <div className="fl-row">

                    <div className={`fl-column grow${props.busy ? ' busy-no-interaction' : ''}`}>

                        <div className="fl-row grow">
                            {/* <div className="grow"></div> */}
                            <HexColorPicker color={currentVal} onChange={confirmVal} />
                            {/* <div className="grow"></div> */}
                        </div>
                        <hr />
                        <div className="fl-column compact">
                            <div className="fl-row grow">
                                {/* <div className="grow"></div> */}
                                <div className="v2-module-field-label">{editingColour}</div>
                                <div className="grow"></div>
                            </div>

                            <div className="fl-row">
                                {/* <h5 className="no-bottom-margin">{editingColour}</h5> */}

                                {/* <div className="grow"></div> */}

                                <div className="current-color"
                                    style={{ background: editingVal }}
                                ></div>

                                <FormField
                                    id={"colourPicker"}
                                    placeholder="#000000"
                                    showLabel={false}
                                    type="text"
                                    maxLength={12}
                                    setFunc={setVal}
                                    confirmChangeFunc={confirmVal}
                                    value={currentVal}
                                    showError={false}
                                    className="c-hex-field"
                                />

                                {/* <div className="grow"></div> */}
                            </div>
                        </div>
                        <hr />
                        <div className="colour-swatch-container">
                            <div className="colour-swatch-row">
                                <div className="v2-module-field-label">Color Pallette</div>
                                <div className="grow"></div>
                            </div>
                            <div className="colour-swatch-row">
                                <div className={`colour-swatch${editingColour?.toLowerCase() === 'primary' ? ' selected' : ''}`}
                                    style={{ background: editedCampaignColours[0] }} onClick={(e) => {setEditingColour('PRIMARY'); setCurrentVal(editedCampaignColours[0]); setEditingVal(editedCampaignColours[0]); setEditingIndex(0)}}
                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('PRIMARY: ' + editedCampaignColours[0], e) : null}
                                    onMouseLeave={props.hideTooltipFunc}
                                ></div>
                                <div className={`colour-swatch${editingColour?.toLowerCase() === 'secondary' ? ' selected' : ''}`}
                                    style={{ background: editedCampaignColours[1] }} onClick={(e) => {setEditingColour('SECONDARY'); setCurrentVal(editedCampaignColours[1]); setEditingVal(editedCampaignColours[1]); setEditingIndex(1)}}
                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('SECONDARY: ' + editedCampaignColours[1], e) : null}
                                    onMouseLeave={props.hideTooltipFunc}
                                ></div>
                                <div className={`colour-swatch${editingColour?.toLowerCase() === 'tertiary' ? ' selected' : ''}`}
                                    style={{ background: editedCampaignColours[2] }} onClick={(e) => {setEditingColour('TERTIARY'); setCurrentVal(editedCampaignColours[2]); setEditingVal(editedCampaignColours[2]); setEditingIndex(2)}}
                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('TERTIARY: ' + editedCampaignColours[2], e) : null}
                                    onMouseLeave={props.hideTooltipFunc}
                                ></div>
                            {/* </div>
                            <div className="colour-swatch-row"> */}
                                {editedCampaignColours.length > 3 && editedCampaignColours.slice(3).map((colour, index) => {
                                    return (
                                        <div key={index} className={`colour-swatch${editingColour?.toLowerCase() === 'color' + (index + 4) ? ' selected' : ''}`}
                                            style={{ background: colour }} onClick={(e) => {setEditingColour('COLOR' + (index + 4)); setCurrentVal(colour); setEditingVal(colour); setEditingIndex(index + 3)}}
                                            onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('COLOR' + (index + 4) + ': ' + colour, e) : null}
                                            onMouseLeave={props.hideTooltipFunc}
                                        ></div>
                                    )
                                })}
                                <div className={`add-btn`} 
                                    onClick={addNewColour}
                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('Add New Colour', e) : null}
                                    onMouseLeave={props.hideTooltipFunc}
                                >
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.plus, IconJsxer.ICON_STYLES.roundPanelButtonSmall)}
                                </div>
                            </div>
                        </div>
                        <hr />
                        {/* <button className={`standard-button${props.busy ? ' not-allowed' : ''}`} onClick={saveChanges}>{props.busy ? 'Saving - Please Wait.' : 'Save Changes'}</button> */}
                        <div className="fl-row">
                            <div className="bottom-button" onClick={saveChanges}>Save Changes</div>
                            <div className="bottom-button cancel" onClick={props.exitEditMode}>Cancel</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EditColourPalletteContent;
